import type { ToeReportRowDto } from "@/api/dtos";
import type { ToeReportRow } from "@/api/report/_models/ToeReport";

const KEY = "Order #";

/** DTO → domain for one TOE row: the "Order #" dedupe key lifted to `id`, every column kept in `fields`. */
export const toToeReportRowFromDto = (dto: ToeReportRowDto): ToeReportRow => {
  const id = dto[KEY] ?? "";

  return {
    id,
    fields: dto,
  };
};
